import { styled } from '@mui/system';
/* import COLORS from '../../../theme/Colors';
import FONTS_FAMILY from '../../../theme/FontsFamily';
 */

export const Container = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
});
